export const surveyEndPoint = `surveys`;
export const RedirectURLsEndPoint = `redirect-urls`;
